/**
 * مصدر موحد لهيكل القائمة الجانبية.
 * يُستخدم في AppMenu وبحث الهيدر.
 */
export function getMenuModel(isAdmin) {
  return [
    {
      label: "الرئيسية",
      items: [{ label: "الصفحة الرئيسية", icon: "pi pi-fw pi-home", to: "/" }],
    },
    {
      label: "المستخدمين",
      items: [
        { label: "الادمن", icon: "pi pi-user", to: "/users/admin" },
        { label: "التجار", icon: "pi pi-user-plus", to: "/users/dealer" },
        { label: "المندوبين", icon: "pi  pi-users", to: "/users/client" },
      ],
    },

    {
      label: "الطلبات",
      items: [
        { label: "انشاء طلب", icon: "pi pi-plus", to: "/order/create" },
        {
          label: "الطلبات الداخلية",
          icon: "pi pi-cart-plus",
          to: "/order/internal/index",
        },
        {
          label: "الطلبات الخارجية",
          icon: "pi pi-cart-plus",
          to: "/order/external/index",
        },
        {
          label: " طلبات المرتجع الداخلية",
          icon: "pi pi-refresh",
          to: "/order/internal/return",
        },
        {
          label: " طلبات المرتجع الخارجية",
          icon: "pi pi-refresh",
          to: "/order/external/return",
        },
      ],
    },

    {
      label: "التجار",
      items: [
        { label: "سند قبض", icon: "pi pi-file-import", to: "/catch/index" },
      ],
    },

    {
      label: "النسب",
      items: [
        {
          label: "نسب المندوبين",
          icon: "pi pi-chart-bar",
          to: "/ratio/index",
        },
        {
          label: "النسب المستلمة",
          icon: "pi pi-check-circle",
          to: "/ratio/ratio",
        },
      ],
    },

    {
      label: "التقارير",
      items: [
        {
          label: "تقرير التجار",
          icon: "pi pi-users",
          to: "/reports/dealer",
        },
        {
          label: "دفعات التجار",
          icon: "pi pi-wallet",
          to: "/reports/payments",
        },
        {
          label: "تقرير الربح من تاجر",
          icon: "pi pi-percentage",
          to: "/reports/profit",
        },
        {
          label: "تقرير الربح من كل التجار",
          icon: "pi pi-chart-bar",
          to: "/reports/all-profit",
        },
        {
          label: "تقرير مبيعات المندوبين",
          icon: "pi pi-chart-line",
          to: "/reports/dealer-sales",
        },
        {
          label: "تقرير مبيعات التجار",
          icon: "pi pi-chart-line",
          to: "/reports/dealer-all-sales",
        },
      ],
    },
  ].filter(Boolean);
}

/**
 * تحويل القائمة إلى مصفوفة مسطحة للبحث: [{ label, to, section, icon }]
 */
export function getFlatMenuItems(isAdmin) {
  const model = getMenuModel(isAdmin);
  const flat = [];
  for (const section of model) {
    if (!section || !section.items) continue;
    for (const item of section.items) {
      if (item.to) {
        flat.push({
          label: (item.label || "").trim(),
          to: item.to,
          section: section.label || "",
          icon: item.icon || "pi pi-fw pi-file",
        });
      }
    }
  }
  return flat;
}
